import { type ReactElement } from 'react';

import { useI18n } from '@/i18n';

export function AccessDeniedScreen(): ReactElement {
  const { t } = useI18n();

  return (
    <div className="flex min-h-[50vh] items-center justify-center p-4 text-center">
      <div>
        <h1 className="mb-2 text-lg font-semibold">{t('auth.accessDenied')}</h1>
        <p className="text-sm text-muted">{t('auth.permissionDeniedHint')}</p>
      </div>
    </div>
  );
}
